// extracted by mini-css-extract-plugin
export default {"block":"Hb3EG","content":"exRSc","heading-title":"uft2B","actions":"WBTAm"};